/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.02"
        height="18.78"
        viewBox="0 0 19.02 18.78"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M.95 18.78v-.14a25.12 25.12 0 0 1 1.09-2.81 10 10 0 0 0 3.46.59 12.33 12.33 0 0 0 6.18-1.73c7.37-4.21 7.3-13.64 7.29-13.77V.56l-.34-.1A15 15 0 0 0 5.9 3.06a12 12 0 0 0-4.63 12.06A28 28 0 0 0 0 18.34v.14ZM6.54 3.87a14.37 14.37 0 0 1 11.47-2.55c-.06 1.74-.69 9-6.78 12.5a10.56 10.56 0 0 1-8.73 1.09c3.8-7.63 9.83-10 9.89-10h.14l-.35-.94h-.14a21.65 21.65 0 0 0-10 9.6 10.78 10.78 0 0 1 4.45-9.69Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'LeafIcon';

export default Icon;
